import { render } from "./UsersIcon.vue?vue&type=template&id=7bdcb017&scoped=true"
import script from "./UsersIcon.vue?vue&type=script&lang=js"
export * from "./UsersIcon.vue?vue&type=script&lang=js"

import "./UsersIcon.vue?vue&type=style&index=0&id=7bdcb017&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdcb017"]])

export default __exports__